import React, { useState, useEffect } from "react";
import api from "../services/api";
import "./SelfProductAdminForm.css";

const SelfProductAdminForm = () => {

  // ============================
  // 🔐 LOGIN VALIDATION
  // ============================
  const isLoggedIn = localStorage.getItem("cc_auth") === "true";
  const role = localStorage.getItem("cc_role");
  const isAdmin = role?.toLowerCase() === "admin";

  if (!isLoggedIn || !isAdmin) {
    return (
      <div style={{ padding: 20, textAlign: "center" }}>
        <h2>You must be logged in to access this page.</h2>
        <p>Please login again to continue.</p>
      </div>
    );
  }

  // =============================
  // FORM STATES
  // =============================
  const [typeName, setTypeName] = useState("");
  const [meters, setMeters] = useState("");

  const [typeList, setTypeList] = useState([]);

  // ====================================
  // Load existing Product Types
  // ====================================
  const fetchTypes = async () => {
    try {
      const res = await api.get("/selfstore/global-types");
      setTypeList(res.data.types || []);
    } catch (err) {
      console.log("Fetch type error", err);
    }
  };

  useEffect(() => {
    fetchTypes();
  }, []);

  // ====================================
  // SAVE TYPE TO MONGO
  // ====================================
  const saveType = async () => {
    if (!typeName.trim() || !meters.trim()) {
      alert("Please enter Type Name and No. of Meters");
      return;
    }

    const payload = {
      name: typeName.trim(),
      meters: Number(meters),
    };

    try {
      const res = await api.post("/selfstore/add-product-type", payload);

      if (res.data.success) {
        alert("Product Type saved successfully!");
        setTypeName("");
        setMeters("");
        fetchTypes(); // refresh list
      }
    } catch (err) {
      console.log("Save error", err);
      alert("Unable to save Product Type");
    }
  };

  return (
    <div className="admin-form-container">
      <h2>Manage Product Types</h2>

      <label>Product Type Name</label>
      <input
        placeholder="Enter Type Name (e.g., Saree)"
        value={typeName}
        onChange={(e) => setTypeName(e.target.value)}
      />

      <label>No. of Meters</label>
      <input
        type="number"
        placeholder="Example: 5.5"
        value={meters}
        onChange={(e) => setMeters(e.target.value)}
      />

      <button className="btn-submit" onClick={saveType}>
        Save Product Type
      </button>

      <hr />

      <h3>Existing Product Types</h3>

      {typeList.length === 0 ? (
        <p>No types found</p>
      ) : (
        <ul>
          {typeList.map((t, i) => (
            <li key={i}>
              <b>{t.name}</b> - {t.meters} meters
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default SelfProductAdminForm;
